import { useEffect, useState } from "react";
import { Box, TextField, Typography } from "@mui/material";
import { Colors } from "../Colors";

interface NumberInputProps {
  disabled: boolean;
  value: number;
  setter: (value: number) => void;
  label: string;
}

export const NumberInput: React.FC<NumberInputProps> = ({ disabled, value, setter, label }) => {
  const [text, setText] = useState<string>(Number.isFinite(value) ? String(value) : "");

  useEffect(() => {
    setText(Number.isFinite(value) ? String(value) : "");
  }, [value]);

  return (
    <Box display="flex" flexDirection="column" sx={{ mb: 3 }}>
      <Typography variant="body2" fontWeight="bold" sx={{ marginBottom: "8px", color: Colors.coolWhite }}>
        {label}
      </Typography>
      <TextField
        type="number"
        value={text}
        onChange={(e) => {
          const next = e.target.value;
          setText(next);
          const parsed = parseInt(next, 10);
          if (Number.isFinite(parsed)) setter(parsed);
        }}
        onBlur={() => {
          const parsed = parseInt(text, 10);
          if (!Number.isFinite(parsed)) {
            setText(Number.isFinite(value) ? String(value) : "");
          }
        }}
        variant="outlined"
        size="small"
        disabled={disabled}
        sx={{
          width: "45px",
          margin: "0 8px",
          marginTop: "5px",
          "& .MuiInputBase-input": {
            color: "#FFF",
          },
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            background: Colors.textfield,
          },
          "& .MuiOutlinedInput-input": {
            padding: "2px",
            textAlign: "center",
          },
          "& input[type=number]": {
            "-moz-appearance": "textfield", // Firefox
            "&::-webkit-outer-spin-button": {
              "-webkit-appearance": "none", // Chrome, Safari, Edge, Opera
              margin: 0,
            },
            "&::-webkit-inner-spin-button": {
              "-webkit-appearance": "none", // Chrome, Safari, Edge, Opera
              margin: 0,
            },
          },
        }}
      />
    </Box>
  );
};
